import path from "node:path"
import { PropItem } from "../parser/types.js"
import { ComponentProperty } from "../types.js"

export function mapToSupernovaProperty(property: PropItem, entryPath: string): ComponentProperty {
  const defaultValue =
    property.defaultValue && typeof property.defaultValue === "object" && "value" in property.defaultValue
      ? String((property.defaultValue as { value?: unknown }).value ?? "")
      : undefined

  return {
    defaultValue,
    name: property.name,
    required: property.required,
    description: property.description,
    type: property.resolvedType,
    tags: property.tags,
    declarations: property.declarations?.map(declaration => ({
      ...declaration,
      fileName: path.relative(entryPath, declaration.fileName),
    })),
  }
}
